import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-step1',
  templateUrl: './step1.component.html',
  styleUrls: ['./step1.component.scss']
})
export class Step1Component implements OnInit {

  @Input() public fName: string
  @Output() public fNameChange: EventEmitter<string> = new EventEmitter<string>();
  @Input() public lName: string
  @Output() public lNameChange: EventEmitter<string> = new EventEmitter<string>();

  constructor() { }

  ngOnInit() {
  }

  fnameChanged() {
    this.fNameChange.emit(this.fName);
  }
  lnameChanged(){
    this.lNameChange.emit(this.lName);
  }
}
